export const testimonials = [
  {
    name: "Rahul Mehra",
    role: "CEO, DreamTech",
    tagline: "Bought 2BHK in Noida",
    image: "https://i.pinimg.com/236x/ca/28/47/ca28478cd4788b38d99b167e56e0a555.jpg",
    message:
      "The team helped me find my dream home at a great price. Highly recommended!",
    stars: 5,
    testimonial:
      "From the very first call, I felt confident I was in good hands. The team was responsive, understood my needs perfectly, and made the whole home-buying journey completely stress-free. Truly a dream come true!",
    themeColor: "blue-600",
  },
  {
    name: "Priya Sharma",
    tagline: "Sold flat in Gurugram",
    image: "https://i.pinimg.com/474x/de/32/1b/de321bafda78fde6f487fd26b6742d2c.jpg",
    message:
      "Very professional and supportive team. Made the entire selling process smooth.",
    stars: 4,
    testimonial:
      "I was nervous about selling my flat, but the team made everything seamless. Their expertise, market knowledge, and regular updates kept me at ease. I got a great deal and zero headaches!",
    themeColor: "green-600",
  },
  {
    name: "Ankit Verma",
    tagline: "Bought first home in Pune",
    image: "https://i.pinimg.com/236x/4a/b2/af/4ab2af26e00092ca45805920666d5a3e.jpg",
    message:
      "I couldn’t have asked for a better first-home experience. Thank you!",
    stars: 5,
    testimonial:
      "Buying my first home was a huge step, and I was full of doubts. But this team made it so easy — from site visits to paperwork, everything was handled smoothly. I felt informed and supported throughout. Grateful beyond words!",
    themeColor: "blue-600",
  },
];
